<template>
  <DotLottieVue ref="ellieLogoLottie" class="aspect-[1/1]" autoplay loop :speed="0.5" src="/graphics/ellie_logo_new.lottie" />
</template>

<script setup>
const ellieLogoLottie = ref();
</script>

<style lang="scss">
#chatbot-lottie{}
</style>
